import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import i18n from './i18n';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

(async () => {
  document.documentElement.setAttribute('data-i18n-ready', 'false');

  try {
    const saved = localStorage.getItem('lang');
    const nav = (navigator.language || '').toLowerCase();
    const auto = nav.startsWith('nl') ? 'nl' : nav.startsWith('fr') ? 'fr' : 'en';
    const initial = (saved && ['en','nl','fr'].includes(saved)) ? saved : auto;

    if (i18n.resolvedLanguage !== initial) {
      await i18n.changeLanguage(initial);
    }
    document.documentElement.setAttribute('lang', i18n.language || initial);

    // IMPORTANT: load the same namespace you configured in i18n.js
    await i18n.loadNamespaces(['landing']);
  } catch {}

  document.documentElement.setAttribute('data-i18n-ready', 'true');

  ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
})();
